class MultiFilter {
     constructor(items, filters) {
          this.items = items
          this.filters = filters
     }

     buildFilter() {
          let filter = this.filters
          let query = {}
          for (let keys in filter) {
     
                
               if (filter[keys] !== "" && filter[keys] != undefined && filter[keys].constructor !== Array) {
                    query[keys] = filter[keys]
               } else if (filter[keys]  !== "" && filter[keys] != undefined && filter[keys].constructor === Array && filter[keys][0] && filter[keys][1]) {
                    console.log('no', filter[keys] )
                    query[keys] = filter[keys]
               } 
          }
          return query
     }
     checkDate(dt1, dt2) {
          dt1 = new Date(dt1)
          dt2 = new Date(dt2)
          if (dt1 && dt2) {
               return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
          }
     }
     filterData() {
          let query = this.buildFilter() 
          const filteredData = this.items.filter((item, i) => {
               for (let key in query) {
                    console.log(query[key] != item[key])
                    if (query[key].constructor !== Array) {
                         if (query[key] != item[key]) return false
                    } else if (!(this.checkDate(query[key][0], item[key]) >= 0 && this.checkDate(query[key][1], item[key]) <= 0)) {
                         return false
                    }
               }
               return true
          })
          return filteredData
     }
}

// Vue plugin.
const MultiFiltersPlugin = {
     install(Vue, options) {
          Vue.prototype.$MultiFilter = MultiFilter
     }
}
export default MultiFiltersPlugin